import { K8sProvider } from '@cast/shared-types';

// Supported providers for phase 2
export const MANAGED_PROVIDERS = [
  K8sProvider.EKS,
  K8sProvider.KOPS,
  K8sProvider.GKE,
  K8sProvider.AKS,
  K8sProvider.SELF_HOSTED,
];

export const NOT_FOUND_CLUSTER_FAILURE_AGE_DAYS = 7;

export const NOT_FOUND_RECONCILE_ERROR_PATTERNS = [
  'no cluster found',
  'cluster not found',
  'invalid credentials',
] as const;
